import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map, tap } from 'rxjs';
import { environment } from '../environments/environment';
import { SessionService } from './session.service';

export enum LogoutReason {
  UserTriggered = 0
}

@Injectable({ providedIn: 'root' })
export class LogoutService {
  private readonly http = inject(HttpClient);
  private readonly session = inject(SessionService);

  logout(reason = LogoutReason.UserTriggered): Observable<void> {
    return this.http
      .post(`${environment.apiUrl}/Account/LogOff`, { reason }, {
        responseType: 'text',
        withCredentials: true
      })
      .pipe(
        tap(() => this.session.setUser(null)),
        map(() => undefined)
      );
  }
}
